import { ERoutePaths } from "@gift/types";
import { Route } from "react-router-dom";
import { Page_Home } from "./Home";

export default [<Route path={ERoutePaths.HOME} element={<Page_Home />} />];
